import React from 'react'
import { Modal as AntdModal } from 'antd'
import { injectIntl, WrappedComponentProps } from 'react-intl'

interface ConfirmationModalProps extends WrappedComponentProps {
  open: boolean
  title: string
  message: string | JSX.Element
  onOk: () => void
  onCancel: () => void
}

const Modal = ({ open, title, message, onOk, onCancel }: ConfirmationModalProps) => {
  return (
    <AntdModal
      title={title}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      centered
    >
      <>
        {message}
      </>
    </AntdModal>
  )
}
  
export default injectIntl(Modal)
